module.exports = __webpack_public_path__ + "img/block.400ca1be.svg";